import React, { useEffect, useState, useRef, useMemo } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog"; // eslint-disable-next-line no-unused-vars
import { useNavigate } from "react-router-dom"; // Importa useNavigate
import { Traductor } from "../Componentes/Traductor";
import { Formatofecha } from "../Componentes/Formatofecha";
import HistoricoContenedorModal from "./HistoricoContenedorModal";
import UploadDocumentoModal from "../Componentes/UploadDocumentoModal"; // Importar el nuevo modal
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

import "../styles/HistoricoContenedores.css";

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const ListaContenedores = ({ language }) => {
  const [ListaContenedores, setListaContenedores] = useState([]);
  const [filteredListaContenedores, setFilteredListaContenedores] = useState(
    [],
  );
  // const [contenedores, setContenedores] = useState([]); // eslint-disable-next-line no-unused-vars - No utilizado

  const [isEditModalContenedoresOpen, setEditModalContenedoresOpen] =
    useState(false);
  const [selectedContenedor, setSelectedContenedor] = useState(null);
  const [searchText, setSearchText] = useState("");
  const toastCenter = useRef(null);
  const translations = Traductor(language);
  const memoizedContenedorData = useMemo(() => {
    if (selectedContenedor) {
      return { ...selectedContenedor };
    }
    return null;
  }, [selectedContenedor]);

  // Nuevos estados para el modal de mercancía
  // const [isMercanciaModalOpen, setMercanciaModalOpen] = useState(false); // eslint-disable-next-line no-unused-vars - No utilizado
  // const [selectedMercanciaContenedorId, setSelectedMercanciaContenedorId] = useState(null); // eslint-disable-next-line no-unused-vars - No utilizado
  const [isUploadModalOpen, setUploadModalOpen] = useState(false); // Nuevo estado para el modal de carga
  const [contenedorIdToUpload, setContenedorIdToUpload] = useState(null); // Estado para el ID del contenedor a subir

  const { columnsHistoricoContenedores } = Traductor(language);

  useEffect(() => {
    fetchWithAuth(`${API_URL}/api/listahistoricocontenedores`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error en la respuesta del servidor");
        }
        return response.json();
      })
      .then((data) => {
        //console.log(data);
        setListaContenedores(data);
        setFilteredListaContenedores(data); // Carga todos los contenedores por defecto
      })
      .catch((err) => {
        console.error("Error al cargar los contenedores:", err);
      });
  }, []);

  /* const handleEditContenedor = () => { // eslint-disable-next-line no-unused-vars - No utilizado, la lógica se movió a actionTemplate
    // Validar si el estado del pedido permite editar
    if (selectedContenedor && ["CREADO", "ASIGNADO", "DESPACHADO", "FINALIZADO"].includes(selectedContenedor.sNombreEstadoContenedor)) {
      setEditModalContenedoresOpen(true); // Abre el modal si el estado lo permite
      //console.log('Modal de edición abierto');
    } else {
      showMessage("error", translations.title_error, translations.errorEditPedido);
    }
  }; */

  /*   const EliminarContenedor = async (idContenedor) => { // eslint-disable-next-line no-unused-vars
    try {
      //console.log('entramos a la funcion', idContenedor);
      const response = await fetchWithAuth(`${API_URL}/api/eliminar-contenedor/${idContenedor}`, {
        method: "PUT",
      });
      const data = await response.json();
      if (data.codigo === 0) {
        showMessage("success", translations.text_Confirmacion, translations.Contenedoreliminado);
        cargarContenedores();
      } else {
        showMessage("error", translations.title_error, `${translations.error_eliminarContenedor}: ${data.mensaje}`);
      }
    } catch (err) {
      showMessage("error", translations.title_error, `${translations.error_eliminarContenedor}: ${err.message}`);
    }
  }; */

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = ListaContenedores.filter((listacontenedores) => {
      return (
        (listacontenedores.sNroContenedor &&
          listacontenedores.sNroContenedor.toLowerCase().includes(value)) ||
        (listacontenedores.mDescripcion &&
          listacontenedores.mDescripcion.toLowerCase().includes(value)) ||
        (listacontenedores.sSerial &&
          listacontenedores.sSerial.toLowerCase().includes(value))
      );
    });

    setFilteredListaContenedores(filtered);
  };

  /* const handleCallDespachar = async () => { // eslint-disable-next-line no-unused-vars - No utilizado, botón comentado
    if (!selectedContenedor) {
      showMessage("error", translations.title_error, translations.errorNoContenedorSeleccionado || "Por favor, selecciona un contenedor.");
      return;
    }

    try {
      const response = await fetchWithAuth(`${API_URL}/api/contenedores/despachar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ IdContenedor: selectedContenedor.IdContenedor }),
      });
      console.log("Response from stored procedure call:", response, "Id Contenedor", selectedContenedor.IdContenedor);

      const data = await response.json();

      if (response.ok) {
        showMessage(
          "success",
          translations.text_Confirmacion,
          data.message || translations.spLlamadoExitoso || "Procedimiento almacenado llamado con éxito."
        );
        cargarContenedores(); // Recarga la lista de contenedores después de un despacho exitoso
      } else {
        showMessage("error", translations.title_error, data.message || translations.errorLlamarSp || "Error al llamar al procedimiento almacenado.");
      }
    } catch (error) {
      console.error("Error al llamar al procedimiento almacenado:", error);
      showMessage("error", translations.title_error, translations.errorLlamarSpGenerico || "Error genérico al llamar al procedimiento almacenado.");
    }
  }; */

  /* const handleCallFinalizar = async () => { // eslint-disable-next-line no-unused-vars - No utilizado, botón comentado
    if (!selectedContenedor) {
      showMessage("error", translations.title_error, translations.errorNoContenedorSeleccionado || "Por favor, selecciona un contenedor.");
      return;
    }

    try {
      const response = await fetchWithAuth(`${API_URL}/api/contenedores/finalizar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ IdContenedor: selectedContenedor.IdContenedor }),
      });
      console.log("Response from stored procedure call:", response, "Id Contenedor", selectedContenedor.IdContenedor);

      const data = await response.json();

      if (response.ok) {
        showMessage(
          "success",
          translations.text_Confirmacion,
          data.message || translations.spLlamadoExitoso || "Procedimiento almacenado llamado con éxito."
        );
        cargarContenedores(); // Recarga la lista de contenedores después de un despacho exitoso
      } else {
        showMessage("error", translations.title_error, data.message || translations.errorLlamarSp || "Error al llamar al procedimiento almacenado.");
      }
    } catch (error) {
      console.error("Error al llamar al procedimiento almacenado:", error);
      showMessage("error", translations.title_error, translations.errorLlamarSpGenerico || "Error genérico al llamar al procedimiento almacenado.");
    }
  }; */

  const descargarLE = async (idContenedor) => {
    // [EXPERT_ANALYSIS]: NUEVO REQUERIMIENTO (REVERSIÓN) - QUÉ: Ahora ambos botones descargan la "Lista de Empaque" original.
    // POR QUÉ: A petición del usuario para unificar todas las descargas hacia el documento de LE.
    // IMPACTO: El usuario obtiene la Lista de Empaque (LE_contenedor_) al presionar cualquier botón de descarga.

    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/contenedores/descargar-le/${idContenedor}`,
        {
          method: "GET",
        },
      );
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Historico_Contenedor_${idContenedor}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error al descargar LE:", err);
      toastCenter.current?.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo descargar el archivo",
      });
    }

    /* // --- CÓDIGO DE REDIRECCIÓN A RESUMEN (COMENTADO POR REQUERIMIENTO) ---
    const url_cc = `${API_URL}/api/contenedores/descargar-cc/${idContenedor}`;
    window.open(url_cc, "_blank");
    // --- FIN CÓDIGO REDIRECCIÓN --- */
  };

  /* // Redirección dinámica
  const handleNavigate = (idContenedor) => { // eslint-disable-next-line no-unused-vars - No utilizado
    navigate(`/listaContenedores/asociarPedido/${idContenedor}`);
  }; */

  const handleDownloadDocument = (idContenedor) => {
    descargarLE(idContenedor);
  };
  const actionTemplate = (rowData) => (
    <div style={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
      <Button
        id={`btn-historico-ver-${rowData.IdContenedor}`}
        icon="pi pi-eye"
        className="p-button-rounded p-button-info"
        onClick={() => {
          setSelectedContenedor(rowData); // Establece el contenedor seleccionado para edición
          console.log(
            "HistoricoContenedores: selectedContenedor al abrir modal",
            rowData,
          );
          console.log(
            "HistoricoContenedores: idContenedor al abrir modal",
            rowData.IdContenedor,
          );
          setEditModalContenedoresOpen(true); // Abre el modal de edición
        }}
        tooltip={translations.VerMercanciaContenedor}
        tooltipOptions={{ position: "top" }}
      />

      <Button
        id={`btn-historico-subir-${rowData.IdContenedor}`}
        icon="pi pi-upload"
        className="p-button-rounded p-button-info"
        onClick={() => {
          setContenedorIdToUpload(rowData.IdContenedor);
          setUploadModalOpen(true);
        }}
        tooltip="Subir Documento"
        tooltipOptions={{ position: "top" }}
      />
      <Button
        id={`btn-historico-descargar-${rowData.IdContenedor}`}
        icon="pi pi-download"
        className="p-button-rounded p-button-success"
        onClick={() => handleDownloadDocument(rowData.IdContenedor)}
        tooltip="Descargar Resumen Contenedor"
        tooltipOptions={{ position: "top" }}
      />
    </div>
  );

  /* const handleUpdateContenedor = (updatedContenedor) => { // eslint-disable-next-line no-unused-vars - No utilizado
    fetchWithAuth(`${API_URL}/api/contenedores/${updatedContenedor.IdContenedor}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedContenedor),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => {
            showMessage("error", translations.title_error, translations.erroralactualizar);
            throw new Error(translations.erroralactualizar);
          });
        }
        return response.json();
      })
      .then((data) => {
        // 🔹 Actualiza la lista de contenedores sin recargar toda la página
        setListaContenedores((prevContenedores) =>
          prevContenedores.map((contenedor) => (contenedor.IdContenedor === updatedContenedor.IdContenedor ? updatedContenedor : contenedor))
        );
        setEditModalContenedoresOpen(false); // 🔹 Cierra el modal
        setSelectedContenedor(null); // 🔹 Deseleccionar el contenedor para inhabilitar botones
        cargarContenedores(); // 🔹 Recarga la lista de contenedores
        showMessage("success", translations.text_Confirmacion, translations.actualizacion_exitosa);
      })
      .catch((err) => {
        showMessage("error", translations.erroralactualizar, err.message);
      });
  }; */

  /* const fetchContenedores = async () => { // eslint-disable-next-line no-unused-vars - No utilizado
    const res = await fetchWithAuth(`${API_URL}/api/contenedores`);
    const data = await res.json();
    setContenedores(data);
  }; */

  /* const crearContenedor = async () => { // eslint-disable-next-line no-unused-vars - No utilizado, botón comentado
    try {
      // Realizar la solicitud al servidor
      const response = await fetchWithAuth(`${API_URL}/api/postcrearcontenedor`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Validar si la respuesta HTTP fue exitosa (status 200-299)
      if (!response.ok) {
        const errorMessage = `Error en la solicitud: ${response.status}`;
        console.error(errorMessage);
        throw new Error(errorMessage); // Lanza un error para el catch
      }

      // Convertir la respuesta a JSON
      const data = await response.json();

      // Verificar si la respuesta del servidor indica éxito
      if (data.success) {
        cargarContenedores(); // Recarga la lista después de la creación
      } else {
        console.error("Error al crear contenedor:", data.message);
        alert(`Error: ${data.message}`); // Muestra un mensaje al usuario
      }
    } catch (err) {
      // Manejo de errores en el cliente (ejemplo: error de red o servidor caído)
      console.error("Error al crear contenedor:", err.message);
      alert("Hubo un problema al crear el contenedor. Por favor, inténtalo de nuevo más tarde.");
    } finally {
      // Ocultar el indicador de carga, si usaste uno
      console.log("Finalizó la operación de crear contenedor.");
    }
  }; */

  return (
    <>
      <Toast ref={toastCenter} position="top-center" baseZIndex={9999} />
      <ConfirmDialog />
      <div className="contenedorprincipal pagina-historico-contenedores">
        <h1 className="titulo">{translations.HistoricoContenedores}</h1>
        <div className="botonessuperiores">
          {/* <Button label={translations.CrearContenedor} icon="pi pi-plus" className="p-button-success" onClick={crearContenedor} /> */}

          {/* <Button
            label={translations.BotonEditarContenedor}
            icon="pi pi-pencil"
            className="p-button-warning"
            onClick={() => {
              handleEditContenedor();
            }}
            disabled={!selectedContenedor}
          /> */}

          {/* <Button
            label={translations.BotonEliminarContenedor}
            icon="pi pi-delete-left"
            className="p-button-danger"
            disabled={!selectedContenedor}
            onClick={() => {
              if (!["CREADO"].includes(selectedContenedor.sNombreEstadoContenedor)) {
                showMessage("error", translations.estadoincorrecto, translations.estado_eliminar_contenedor);
                return;
              }

              setSelectedContenedor(selectedContenedor);

              confirmDialog({
                message: translations.mje_eliminar_contenedor,
                header: translations.text_Confirmacion,
                icon: "pi pi-question-circle",
                acceptClassName: "p-button-primary",
                rejectClassName: "p-button-outlined",
                acceptLabel: translations.yesbutton,
                rejectLabel: translations.nobutton,
                accept: () => EliminarContenedor(selectedContenedor.IdContenedor),
                reject: () => showMessage("info", translations.accioncancelada, translations.accioncancelada),
              });
            }}
          /> */}
          {/* <Button
            label="Despachar"
            icon="pi pi-truck"
            className="p-button-secondary"
            onClick={handleCallDespachar}
            disabled={
              !selectedContenedor ||
              selectedContenedor.sNombreEstadoContenedor === "DESPACHADO" ||
              selectedContenedor.sNombreEstadoContenedor === "CREADO"
            }
            /* tooltip="Despacha el contenedor seleccionado" 
            tooltipOptions={{ position: "top" }}
          /> */}
          {/* <Button
            label="Finalizar"
            icon="pi pi-check-square"
            className="p-button-danger"
            onClick={handleCallFinalizar}
            disabled={!selectedContenedor || selectedContenedor.sNombreEstadoContenedor !== "DESPACHADO"}
            /* tooltip="Finalizar el contenedor seleccionado" 
            tooltipOptions={{ position: "top" }}
          /> */}
        </div>

        {isEditModalContenedoresOpen && selectedContenedor && (
          <HistoricoContenedorModal
            key={selectedContenedor?.IdContenedor} // Añadir esta línea
            isOpen={isEditModalContenedoresOpen}
            Contenedor={memoizedContenedorData}
            language={language}
            onClose={() => setEditModalContenedoresOpen(false)}
          />
        )}

        {/* Modal para subir documentos */}
        {isUploadModalOpen && (
          <UploadDocumentoModal
            isOpen={isUploadModalOpen}
            onClose={() => setUploadModalOpen(false)}
            idContenedor={contenedorIdToUpload}
            language={language}
          />
        )}

        <div
          className="contenedor-lista-contenedores"
          style={{ width: "95%", margin: "0 auto" }}
        >
          <div style={{ marginBottom: "2px", textAlign: "center" }}>
            <input
              id="filtro-historico-contenedores-search"
              type="text"
              placeholder={translations.searchPlaceholder}
              value={searchText}
              onChange={handleSearch}
              style={{ padding: "5px", width: "200px" }}
            />
          </div>

          <DataTable
            value={filteredListaContenedores}
            paginator
            rows={12}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} contenedores"
            responsiveLayout="scroll"
            selectionMode="single"
            sortMode="multiple"
            sortField="IdContenedor"
            sortOrder={-1} // -1 = Descendente (más recientes primero)
            stripedRows
            showGridlines
            removableSort
            className="tabla-lista-contenedores"
            selection={selectedContenedor}
            //onSelectionChange={(e) => setSelectedContenedor(e.value)}
            onSelectionChange={(e) => {
              setSelectedContenedor(e.value);
            }}
          >
            {columnsHistoricoContenedores.map((col, index) => (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                body={(rowData) => {
                  let content = rowData[col.field];
                  // Si la columna es una fecha, usa Formatofecha
                  if (["dFechaDespacho"].includes(col.field)) {
                    content = Formatofecha(rowData[col.field]);
                  }
                  return (
                    <span
                      id={`historico-contenedor-celda-${rowData.IdContenedor}-${col.field}`}
                    >
                      {content}
                    </span>
                  );
                }}
                sortable
              />
            ))}

            <Column
              header={translations.Acciones}
              body={actionTemplate}
              style={{ textAlign: "center", width: "10%" }}
              headerStyle={{ textAlign: "center" }}
            />
          </DataTable>
        </div>
      </div>
    </>
  );
};

export default ListaContenedores;
